// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__-ZG8Q"};